import styled from 'styled-components';
import { Radio } from 'antd';
import { baseOverlay } from '../styles';

const MapRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;

  .ant-radio-button-wrapper,
  .ant-radio-button-wrapper-checked {
    :first-child {
      border-radius: 0.25rem 0 0 0.25rem;
    }
    &:last-child {
      border-radius: 0 0.25rem 0.25rem 0;
    }
  }
`;

const MapRadioButton = styled(Radio.Button)`
  ${baseOverlay};

  &.ant-radio-button-wrapper-checked {
    background-color: #0071cd !important;
    border-color: #0071cd !important;
  }
`;

export { MapRadioGroup, MapRadioButton };
